var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('m-loader',{attrs:{"is-loading":_vm.loading}}):_c('m-dashboard',{staticClass:"mt-4",attrs:{"dashboard-settings-id":_vm.dashboardId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }